import { render } from "./DisparoAlertas.vue?vue&type=template&id=52f54b51"
import script from "./DisparoAlertas.vue?vue&type=script&lang=js"
export * from "./DisparoAlertas.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__